<template>
	<div>
        <apexchart type=line height=400 ref="chart" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
    components: {
        apexchart
    },
    methods: {
        configuraGrafico() {
            var context = this
            context.listaSemana = []
            context.seriesMontada = []
            context.listaIndiceAcumulado = []

            var listaMetaMortalidadeSemana = []
            if (this.itemTabelaMetaMortalidade)
            {
                listaMetaMortalidadeSemana = this.itemTabelaMetaMortalidade.pontos
            }

            if (listaMetaMortalidadeSemana)
            {
                var listaOrdenada = listaMetaMortalidadeSemana.sort((a, b) => {
                    return (
                        a.nrDia - b.nrDia
                    )
                })
                var listaLimiteMortalidadePontos = []
                listaOrdenada.forEach(function(item) {
                    listaLimiteMortalidadePontos.push(item.mortalidade)
                    if (context.listaSemana.indexOf(item.nrDia) == -1) {
                        context.listaSemana.push(item.nrDia)
                    }
                })

                var itemMetaMortalidade = {
                    name: 'Limite de mortalidade',
                    type: 'line',
                    data: listaLimiteMortalidadePontos
                }

                context.seriesMontada.push(itemMetaMortalidade)
            }

            for (var i in this.values)
            {
                context.listaIndiceAcumulado = []
                this.values[i].forEach(function(item){
                    context.listaIndiceAcumulado.push(item.nrIndiceAcc.toFixed(3))
                })
                var itemIndiceBaixaAcc = {
                    name: i,
                    type: 'line',
                    data: context.listaIndiceAcumulado
                }
                context.seriesMontada.push(itemIndiceBaixaAcc)   
            }
        }
    },
    data: function() {
        this.configuraGrafico()
        var context = this
        return {
            seriesMontada: [],
            listaIndiceAcumulado: [],
            listaSemana: [],
            chartOptions: {
                stroke: {
                    curve: 'straight',
                    dashArray: [5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    width: [3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
                },
                xaxis: {
                    type: 'integer',
                    categories: context.listaSemana,
                    title: {
                        text: 'Semana',
                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                    fontSize: '14px',
                    labels: {
                        useSeriesColors: false
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                        return val + '%'
                        }
                    }
                },
            },
            series: context.seriesMontada
        }
    },
    props: {
        values: {
            type: Object,
            default: () => ({})
        },
        itemTabelaMetaMortalidade: Object
    },
    watch: {
        'values' () {
            this.configuraGrafico()
            var context = this
            this.$refs.chart.updateSeries([{
              data: context.seriesMontada
            }])
        },
    },
}

</script>